import { Component } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Location } from '@angular/common';

import { ConstantValues } from '../app/bpg-common/models/bpg-constants';
import { environment } from '../environments/environment';
import { BpgCommonService } from '../app/bpg-common/services/bpg-common.service';
import { EnvironmentConfiguration } from './environment/services/environment.configuration';
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  path = ''
  isActive: boolean = false;
  constructor(
    private router: Router,
    private location: Location,
    //
    private bpgCommonService: BpgCommonService,
    private environment1: EnvironmentConfiguration) {

    router.events.subscribe(async event => {

      if (event instanceof NavigationStart) {
        if (window.location.href.indexOf('code') != -1) {
          //this.spinner.show();
          const url = window.location.href.split('?')[1]
          if (url.indexOf('error') != -1) {

          }
          else {
            const codeResponse = window.location.href.split('?')[1].split('code=')[1].split('&')[0];
            sessionStorage.setItem('codeResponse', codeResponse)

            //this.bpgCommonService.userLogin();
          }
        }
      }

    })
    //adalService.init(this.environment1.adalConfig);

    this.router.events.subscribe((val) => {
      this.path = this.location.path();
    });


  }
  title = 'bpg-webapp';
  menuDisplay: any;
  // adalLogin: boolean;
  // adalLoggedIn: boolean;
  expiryMsg = `Your session will expire in 5 minutes. Kindly save all your changes`;
  expiryTime: number;
  expiryWarnTime: number;
  interval: any;
  timeInterval: any;

  ngOnInit() {

    // this.adalLogin = this.environment1.loginADAL;
    // this.adalService.handleWindowCallback();
    // this.adalLoggedIn = this.adalService.userInfo.authenticated;
    window.setTimeout(() => {
      $('#tokenExpiry').modal('show');
    }, (600000 * 5));
    if (sessionStorage.getItem('id_token') != null && sessionStorage.getItem('XAapiKey') != null)    {
      this.isActive = true;
    }
    if (!this.isActive || sessionStorage.getItem('id_token') == null || sessionStorage.getItem('XAapiKey') == null)    {
      this.interval = setInterval(() => {
        console.log(this.isActive)
      if (sessionStorage.getItem('id_token') != null && sessionStorage.getItem('XAapiKey') != null)    {
          this.isActive = true;
          clearInterval(this.interval)
        }
     }, 1000);    }

    // if (sessionStorage.getItem('loginSuccess') == null || (sessionStorage.getItem('loginSuccess') == undefined))
    //   setTimeout(function () {
    //     if (sessionStorage.getItem('loginSuccess') == 'true') {
    //       this.isActive = true;
    //     }
    //   }.bind(this), 3500);
    window.setTimeout(() => {
      this.refreshToken();
    }, (600000 * 5));
    if (this.environment1.envName == 'default' || this.environment1.envName == 'local' || this.environment1.envName == 'staging') {
      localStorage.setItem('userManagementUrl', this.environment1.apiBaseUrl + '7000');
      localStorage.setItem('eventManagementUrl', this.environment1.apiBaseUrl + '7001');
      localStorage.setItem('financialManagementUrl', this.environment1.apiBaseUrl + '7002');
    } else if (this.environment1.envName == 'qa' || this.environment1.envName == 'prod') {
      localStorage.setItem('userManagementUrl', this.environment1.apiBaseUrl);
      localStorage.setItem('eventManagementUrl', this.environment1.eventapiBaseUrl);
      localStorage.setItem('financialManagementUrl', this.environment1.financeapiBaseUrl);
    }
    else {
      localStorage.setItem('userManagementUrl', this.environment1.apiBaseUrl);
      localStorage.setItem('eventManagementUrl', this.environment1.apiBaseUrl);
      localStorage.setItem('financialManagementUrl', this.environment1.apiBaseUrl);
    }

    // for (let i = 0; i < sessionStorage.length; i++) {
    //   let key = sessionStorage.key(i);
    //   let value = sessionStorage.getItem(key);
    //   if (key.indexOf('expiration') != -1) {
    //     this.expiryTime = Number(sessionStorage.getItem(key)) * 1000 - (5 * 60 * 1000);
    //     console.log('Expiry Time  :: ', new Date(this.expiryTime));
    //     this.expiryWarnTime = this.expiryTime - (5 * 60 * 1000);
    //     break;
    //   }
    // }

    // this.interval = setInterval(() => {
    //   var today: any = new Date()
    //   var nowParse: any = today.getTime()
    //   if (nowParse >= this.expiryWarnTime) {
    //     // console.log('expiry period');
    //     this.timeInterval = setInterval(() => {
    //       var now = +new Date();
    //       var exp = +new Date(this.expiryTime);

    //       // Find the difference between now an the count down date
    //       var diff = Math.abs(exp - now) / 1000;  // console.log('Difference = ', diff);

    //       // get minutes
    //       var minutes = Math.floor(diff / 60) % 60; // console.log("Difference (Minutes): " + minutes);

    //       // get seconds
    //       var seconds = (diff % 60).toFixed(0); // console.log("Difference (Seconds): " + seconds);

    //       // Output the result"
    //       this.expiryMsg = `Your session will expire in ${minutes} minute(s) and ${seconds} second(s). Please save all your changes`
    //       //  console.log(this.expiryMsg);

    //       // If the count down is over, clear the setInterval and close the modal
    //       if (diff <= 0) {
    //         clearInterval(this.timeInterval);
    //         $('#tokenExpiry').modal('hide');
    //       }
    //     }, 1000);
    //     $('#tokenExpiry').modal('show');
    //     clearInterval(this.interval);
    //   }
    // }, 60000);
  }
  async refreshToken() {
    this.bpgCommonService.refreshToken()

  }
  clearTime() {
    $('#tokenExpiry').modal('hide');
  }
}

